import {
  ADICIONAR_DADOS_PAGAMENTO_ENCOMENDA, ADICIONAR_FORMAS_PAGAMENTO_ENCOMENDA, ADICIONAR_NOTA_FISCAL, LIMPAR_DADOS_PAGAMENTO_ENCOMENDA, REMOVER_NOTA_FISCAL
} from '../../actions/types'
import { realParaNumber } from '../../util/numberUtil';

const initialState = undefined;
const value = {
  tipoProduto: '',
  tipoCalculo: '',
  valorCombinado: '0',
  valorKg: '0',
  volume: '0',
  quantidadeKg: '0',
  valorCalculado: '0',
  observacao: '',
  notasFiscais: [],
  formasPagamento: [],
  habilitadoValorDeclarado: false,
  valorProduto: 0,
  habilitaValorNotaFiscal: false,
  habilitadoSeguro: false,
  valorTotalNotaFiscal: 0,
  taxaSeguro: 0,
  valorSeguro: 0,
  itensMetroCubico: [],
  volumeM3: '0,000',
};

export default function reducerDadosPagamentoEncomenda (state = value, action = initialState) {
  switch (action.type) {
    case ADICIONAR_DADOS_PAGAMENTO_ENCOMENDA: {
      return action.payload
    }

    case ADICIONAR_NOTA_FISCAL: {
      const notafiscal = action.payload;
      const notasFiscais = Object.assign([], state.notasFiscais);      
      notasFiscais.push(notafiscal);      
      const valorTotalNotaFiscal = notasFiscais.map(it => realParaNumber(it.valor)).reduce((acc, valor)=> acc + valor, 0);
      
      let valorSeguro = 0      
      if (state.habilitaValorNotaFiscal && state.taxaSeguro > 0) {
        valorSeguro = valorTotalNotaFiscal * state.taxaSeguro;
      }
      
      return { ...state, notasFiscais, valorTotalNotaFiscal, valorSeguro }
    }

    case ADICIONAR_FORMAS_PAGAMENTO_ENCOMENDA: {
      return { ...state, formasPagamento: action.payload }
    }

    case REMOVER_NOTA_FISCAL: {
      const notafiscal = action.payload;
      const notasFiscais = Object.assign([], state.notasFiscais);
      const novaNotasFiscais = notasFiscais.filter(it => it.ordem !== notafiscal.ordem);      
      const valorTotalNotaFiscal = novaNotasFiscais.map(it => realParaNumber(it.valor)).reduce((acc, valor) => acc + valor, 0);
      
      let valorSeguro = 0
      if (state.habilitaValorNotaFiscal && state.taxaSeguro > 0) {
        valorSeguro = valorTotalNotaFiscal * state.taxaSeguro;
      }

      return { ...state, notasFiscais: novaNotasFiscais, valorTotalNotaFiscal, valorSeguro }
    }

    case LIMPAR_DADOS_PAGAMENTO_ENCOMENDA: {
      return value;
    }

    default: {
      return state
    }
  }
}
